import Vue from "vue";
import Router from "vue-router";
import { authGuard } from "@/Auth/authGuard";

import DashboardLayout from "@/pages/Layout/DashboardLayout";
import ErrorPage from "@/pages/Error";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/dashboard/Dashboard";

import PlantsWithoutStatInsps from "@/pages/stat-insp/PlantsWithoutStatInsps";
import StatInspByFilter from "@/pages/stat-insp/StatInspFilter";
import StatInspItemFilter from "@/pages/stat-insp/StatInspItemFilter";
import StatInspView from "@/pages/stat-insp/stat-insp/StatInspView";
import StatInspItemView from "@/pages/stat-insp/stat-insp-item/StatInspItemView";

import QuotesList from "@/pages/quotes/QuoteListings";
import QuotesCompletedList from "@/pages/quotes/QuoteCompletedListings";
import QuotesRejectedList from "@/pages/quotes/QuoteRejectedListings";
import AddQuote from "@/pages/quotes/AddQuote";

import ClientListing from "@/pages/portfolio/ClientListing";
import Client from "@/pages/portfolio/Client";
import Site from "@/pages/portfolio/Site";
import Building from "@/pages/portfolio/Building";
import Plant from "@/pages/portfolio/Plant";

import QuoteView from "@/pages/quotes/QuoteView";
import ReissueQuote from "@/pages/quotes/ReissueQuote";

Vue.use(Router);

let statInspRoutes = {
  path: "/stat-insp",
  component: DashboardLayout,
  name: "Stat-Insp Section",
  redirect: "stat-insp-list",
  children: [
    {
      path: "plants-without-stat-insps",
      name: "Plants without Stat. Insp.",
      components: { default: PlantsWithoutStatInsps },
      beforeEnter: authGuard
    },
    {
      path: "stat-insp-list",
      name: "List Statutory Inspections",
      components: { default: StatInspByFilter },
      beforeEnter: authGuard
    },
    {
      path: "stat-insp-items-filter",
      name: "Stat Insp Items Filter",
      components: { default: StatInspItemFilter },
      props: route => ({
        typeId: route.query.typeId,
        statusId: route.query.statusId
      }),
      beforeEnter: authGuard
    },
    {
      path: ":statInspId",
      name: "Statutory Inspection",
      components: { default: StatInspView },
      beforeEnter: authGuard
    },
    {
      path: ":statInspId/item/:statInspItemId",
      name: "Stat Insp Item View",
      components: { default: StatInspItemView },
      beforeEnter: authGuard
    }
  ]
};

let quoteRoutes = {
  path: "/quotes",
  component: DashboardLayout,
  name: "Quotes Section",
  redirect: "Quotes",
  children: [
    {
      path: "live",
      name: "Live Quotes",
      components: { default: QuotesList },
      props: route => ({
        clientId: route.query.clientId,
        contractorRegionId: route.query.contractorRegionId,
        statusId: route.query.statusId
      }),
      beforeEnter: authGuard
    },
    {
      path: "completed",
      name: "Completed Quotes",
      components: { default: QuotesCompletedList },
      beforeEnter: authGuard
    },
    {
      path: "rejected",
      name: "Rejected Quotes",
      components: { default: QuotesRejectedList },
      beforeEnter: authGuard
    },
    {
      path: "add-quote",
      name: "Add Quote",
      components: { default: AddQuote },
      beforeEnter: authGuard
    },
    {
      path: ":quoteId/reissue",
      name: "Reissue Quote",
      components: { default: ReissueQuote },
      beforeEnter: authGuard
    },
    {
      path: ":quoteId",
      name: "Quote",
      components: { default: QuoteView },
      beforeEnter: authGuard
    }
  ]
};

let portfolioRoutes = {
  path: "/portfolio",
  component: DashboardLayout,
  name: "Portfolio",
  redirect: "Clients",
  children: [
    {
      path: "clients",
      name: "Portfolio Clients",
      components: { default: ClientListing },
      beforeEnter: authGuard
    },
    {
      path: "clientId=:clientId",
      name: "Client Details",
      components: { default: Client },
      beforeEnter: authGuard
    },
    {
      path: "siteId=:siteId",
      name: "Site Details",
      components: { default: Site },
      beforeEnter: authGuard
    },
    {
      path: "buildingId=:buildingId",
      name: "Building Details",
      components: { default: Building },
      beforeEnter: authGuard
    },
    {
      path: "plantId=:plantId",
      name: "Plant Details",
      components: { default: Plant },
      beforeEnter: authGuard
    }
  ]
};

const router = new Router({
  // Assumes we being served via something "SPA aware" with index.html redirects
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "Landing"
    },
    statInspRoutes,
    quoteRoutes,
    portfolioRoutes,
    {
      path: "/",
      component: DashboardLayout,
      children: [
        {
          path: "landing",
          name: "Landing",
          components: { default: Landing },
          beforeEnter: authGuard
        },
        {
          path: "dashboard",
          name: "Dashboard",
          components: { default: Dashboard },
          beforeEnter: authGuard
        }
      ]
    },
    {
      path: "/error",
      name: "Error",
      components: { default: ErrorPage },
      beforeEnter: authGuard,
      meta: { isErrorPage: true }
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
